import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import InventoryPage from './pages/InventoryPage';
import ContactPage from './pages/ContactPage';
import RequestPartPage from './pages/RequestPartPage';
import NotFoundPage from './pages/NotFoundPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Set page title on route change
function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const titles = {
      '/': 'Brantford Auto Wrecking & Salvage | Quality Used Auto Parts',
      '/about': 'About Us | Brantford Auto Wrecking & Salvage',
      '/inventory': 'Parts Inventory | Brantford Auto Wrecking & Salvage',
      '/contact': 'Contact | Brantford Auto Wrecking & Salvage',
      '/request-part': 'Request a Part | Brantford Auto Wrecking & Salvage',
    };
    document.title = titles[pathname] || 'Brantford Auto Wrecking & Salvage';
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <PageTitle />
      <Layout>
        <Routes>
          <Route path="/"             element={<HomePage />} />
          <Route path="/about"        element={<AboutPage />} />
          <Route path="/inventory"    element={<InventoryPage />} />
          <Route path="/contact"      element={<ContactPage />} />
          <Route path="/request-part" element={<RequestPartPage />} />
          <Route path="*"             element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
